
import { throttle } from 'throttle-debounce';

export default {
  data () {
    return {
    }
  },
  props: {
    info: {
      type: Object,
      default () {
        return {
          show: false,
          title: "",
          content: "",
          cancelBtnText: "Cancel",
          confirmBtnText: "OK",
          cancelBtnClick: () => { },
          confirmBtnClick: () => { },
        }
      }
    }
  },
  methods:{
    btnCancel:throttle(1000, function() {
      this.info.cancelBtnClick && this.info.cancelBtnClick()
    }),
    btnConfirm:throttle(1000, function() {
      this.info.confirmBtnClick && this.info.confirmBtnClick()
    }),
  }
}
